import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";

@Injectable()
export class ReturnEndToEndSlaService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService) {}

  getEndToEndSLA(url, params) {
    const option = {
      method: "GET",
      url: url, // "./assets/data/p-d-otif.json",
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processEndToEndSLA.bind(this))
    );
  }

  processEndToEndSLA(data: any) {
    if (Object.keys(data.data).length === 0) return null;
    const sla = [],
      volume = [],
      under_process = [];

    const processedData = this.drillDownData(data.data);

    const __v2Data = processedData["data"];
    const dataKeys = processedData["dataKeys"];
    const allData = processedData["dataObject"];
    const allKey = processedData["allKey"];

    const chart1 = {
      data: [Number((allData["under_process"]).toFixed(2)), Number((allData["sla"]).toFixed(2))],
      allKey: allKey
    };

    if (dataKeys.length) {
      dataKeys.map(_dataName => {
        sla.push(Number(__v2Data[_dataName]["data"]["sla"].toFixed(2)));
        volume.push(Number(__v2Data[_dataName]["data"]["volume"].toFixed(2)));
        under_process.push(
          Number(__v2Data[_dataName]["data"]["under_process"].toFixed(2))
        );
      });
    }
    const chart2 = [dataKeys, under_process, sla, volume];
    return { chart1, chart2 };
  }

  createChart(chartData, Options) {
    const chart1 = JSON.parse(JSON.stringify(HSET.chart1));
    const chart2 = JSON.parse(JSON.stringify(HSET.chart2));

    chart1.series[0].data = [chartData.chart1["data"][0]];
    chart1.series[1].data = [chartData.chart1["data"][1]];
    chart1.xAxis.categories = [chartData.chart1["allKey"]];

    chart2.xAxis.categories = chartData.chart2[0]
    chart2.series[0].data = chartData.chart2[1];
    chart2.series[1].data = chartData.chart2[2];
    chart2.series[2].data = chartData.chart2[3];

    return { chart1, chart2 };
  }

  drillDownData(data) {
    let dataKeys = [];
    let allKey = "All";
    let dataObject = { ...data["data"] };
    delete data["data"];

    if (Object.keys(data).length > 1) {
      dataKeys = Object.keys(data);
    } else if (Object.keys(data).length === 1) {
      allKey = Object.keys(data)[0];
      data = data[Object.keys(data)[0]];
      dataObject = { ...data["data"] };
      delete data["data"];
      if (Object.keys(data).length > 1) {
        dataKeys = Object.keys(data);
      } else if (Object.keys(data).length === 1) {
        allKey = Object.keys(data)[0];
        data = data[Object.keys(data)[0]];
        dataObject = { ...data["data"] };
        delete data["data"];
        dataKeys = Object.keys(data);
      }
    }
    return { data, dataKeys, dataObject, allKey };
  }
}
